// 服务器时间管理器
// 用于校准本地时钟，避免客户端时钟漂移导致的签名 timestamp 偏差（40122 签名超时）。
// 与扩展端(woofootball_web/replay_shield)同机制。纯内存、无 window 依赖，SSR 安全。

type ServerTimeState = {
  offset: number
  syncedAt: number
}

const TTL_MS = 10 * 60 * 1000 // 10min TTL（缩短：避免长时间不请求时 offset 陈旧）
const OFFSET_THRESHOLD_MS = 10 * 1000 // 偏移 >10s 才更新本地 offset

class ServerTimeManager {
  private state: ServerTimeState = { offset: 0, syncedAt: 0 }

  syncFromResponse(dateHeader: string | null | undefined): void {
    if (!dateHeader) return
    const serverMs = Date.parse(dateHeader)
    if (Number.isNaN(serverMs)) return
    const localMs = Date.now()
    const offset = serverMs - localMs
    const now = Date.now()

    if (this.state.syncedAt === 0 || Math.abs(offset - this.state.offset) > OFFSET_THRESHOLD_MS) {
      this.state = { offset, syncedAt: now }
    } else {
      this.state.syncedAt = now
    }
  }

  /**
   * 强制同步（无视 10s 阈值）：用于 40122 签名超时自愈——此时误差已超服务端窗，
   * 必须无条件采纳最新 offset，否则无法纠正。
   */
  forceSyncFromResponse(dateHeader: string | null | undefined): void {
    if (!dateHeader) return
    const serverMs = Date.parse(dateHeader)
    if (Number.isNaN(serverMs)) return
    this.state = { offset: serverMs - Date.now(), syncedAt: Date.now() }
  }

  getTimestampMs(): number {
    if (this.isStale()) {
      return Date.now()
    }
    return Date.now() + this.state.offset
  }

  getTimestampSeconds(): number {
    return Math.floor(this.getTimestampMs() / 1000)
  }

  isStale(): boolean {
    return Date.now() - this.state.syncedAt > TTL_MS
  }

  reset(): void {
    this.state = { offset: 0, syncedAt: 0 }
  }

  getOffset(): number {
    return this.state.offset
  }
}

export const serverTime = new ServerTimeManager()
